export default __webpack_public_path__ + "static/tek_img_03-e8f169db401864959a7718d06f4d86c0.webp";